export class NativeApp {
  /**
   * Checks if the app is running in the native app web view.
   */
  static isNativeApp() {
    return this.isNativeAppV1() || this.isNativeAppV2();
  }
  /**
   * Checks if the app is running in the native app with version < 2.0.0.
   */
  static isNativeAppV1() {
    return typeof window !== "undefined" && (window.native_android || window.native_ios);
  }
  /**
   * Checks if the app is running in the native app with version >= 2.0.0.
   */
  static isNativeAppV2() {
    return typeof window !== "undefined" && window.flutter_inappwebview;
  }
  static async _call(name, ...args) {
    if (this.isNativeAppV1() && window[`native_${name}`]) {
      window[`native_${name}`].postMessage(...args);
    } else if (this.isNativeAppV2()) {
      return await window.flutter_inappwebview.callHandler(name, ...args);
    }
  }
  static async share(text) {
    return this._call("share", text);
  }
  static async vibrate(impact) {
    return this._call("vibrate", impact);
  }
  static async download(url) {
    return this._call("download", url);
  }
  static async requestPermission(permission) {
    return this._call("requestPermission", permission);
  }
  static async rate() {
    return this._call("rate");
  }
  static async scan() {
    return this._call("scan");
  }
  static async setUserId(id) {
    return this._call("setUserId", id);
  }
  static async locate(options) {
    return this._call("locate", options);
  }
  static async getDeviceInfo() {
    return this._call("getDeviceInfo");
  }
  static async uploadImage(options) {
    return this._call("uploadImage", options);
  }
  static async startVirtualParticipation(options) {
    return this._call("startVirtualParticipation", options);
  }
  static async getFirebaseDeviceToken() {
    return this._call("getFirebaseDeviceToken");
  }
  static async showStoreListing() {
    return this._call("showStoreListing");
  }
  static async setBadgeCount(count) {
    return this._call("setBadgeCount", count);
  }
}
